// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
 * Station — 그로우핏 스테이션 공통 셸 + 메뉴 페이지 스타일
 * 디자인 토큰만 사용 (var(--*)), raw hex 사용 금지
 * BEM: .station-* / .station-<page>__element--modifier
 * ================================================================ */

/* ─── 레이아웃 셸 ─────────────────────────────────────────── */
.station-layout {
  display: flex;
  min-height: 100vh;
  background: var(--background);
  color: var(--fg-text-basic);
  font-family: var(--font-sans);
}

.station-layout__main {
  flex: 1 1;
  min-width: 0;
  background: var(--background);
}

.station-layout__content {
  max-width: 1080px;
  margin: 0 auto;
  padding: 40px 48px 80px;
}

/* ─── 사이드바 ────────────────────────────────────────────── */
.station-sidebar {
  flex-shrink: 0;
  width: 260px;
  min-height: 100vh;
  background: var(--fg-bg-cool);
  border-right: 1px solid var(--fg-line, var(--border));
  display: flex;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  transition: width var(--transition-fast, 0.15s ease);
}

.station-sidebar--collapsed {
  width: 64px;
  padding: 14px 8px 18px;
  align-items: center;
}

.station-sidebar__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: var(--fg-text-gray, var(--text-secondary));
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 8px;
  margin: 0 -8px 10px;
  border-radius: var(--radius-md, 6px);
  cursor: pointer;
  transition: background var(--transition-fast, 0.15s ease),
              color var(--transition-fast, 0.15s ease);
}

.station-sidebar__back:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.station-sidebar__back-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.station-sidebar--collapsed .station-sidebar__back {
  align-self: center;
  margin: 0 0 10px;
  padding: 6px;
}

.station-sidebar__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  margin-bottom: 22px;
}

.station-sidebar--collapsed .station-sidebar__top {
  justify-content: center;
}

.station-sidebar__brand {
  display: inline-flex;
  align-items: center;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
  padding: 0;
  height: 28px;
}

.station-sidebar__brand-img {
  height: 24px;
  width: auto;
  display: block;
}

.station-sidebar__toggle {
  border: 0;
  background: transparent;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--fg-text-basic);
}

.station-sidebar__toggle:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.station-sidebar__nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}

.station-sidebar__nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: 0;
  border-radius: var(--radius-md, 6px);
  background: transparent;
  cursor: pointer;
  color: var(--fg-text-basic);
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  transition: background var(--transition-fast, 0.15s ease), color var(--transition-fast, 0.15s ease);
}

.station-sidebar--collapsed .station-sidebar__nav-item {
  justify-content: center;
  padding: 10px 0;
}

.station-sidebar__nav-item:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--fg-text-basic);
}

.station-sidebar__nav-item--active {
  background: var(--background);
  color: var(--fg-text-basic);
  font-weight: 600;
  box-shadow: var(--shadow-sm);
}

.station-sidebar__nav-item--logout {
  margin-top: 12px;
}

.station-sidebar__nav-icon {
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.station-sidebar__nav-label {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.station-sidebar__nav-badge {
  font-size: 12px;
  color: var(--fg-text-gray, var(--text-tertiary));
  font-weight: 500;
}

/* 사이드바 하단 — 알림 벨 + 프로필 카드 */
.station-sidebar__bottom {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 10px;
}

.station-sidebar__bell {
  position: relative;
  border: 0;
  background: transparent;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--fg-text-basic);
}

.station-sidebar__bell:hover {
  background: rgba(0, 0, 0, 0.05);
}

.station-sidebar__bell-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: var(--radius-full, 9999px);
  background: var(--error, #e84545);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.station-sidebar__profile {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  border-radius: var(--radius-lg, 8px);
  background: var(--background);
  cursor: pointer;
  text-align: left;
  transition: background var(--transition-fast, 0.15s ease);
  box-shadow: var(--shadow-sm);
}

.station-sidebar__profile:hover {
  background: var(--surface);
}

.station-sidebar__avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full, 9999px);
  background: var(--gray-200, #e5e7eb);
  color: var(--text-primary);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 13px;
  overflow: hidden;
}

.station-sidebar__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.station-sidebar__profile-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.station-sidebar__profile-head {
  display: flex;
  align-items: center;
  gap: 5px;
}

.station-sidebar__profile-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.station-sidebar__profile-divider {
  color: var(--border, #d1d5db);
  font-size: 11px;
}

.station-sidebar__profile-plan {
  font-size: 11px;
  color: var(--fg-text-gray, var(--text-tertiary));
}

.station-sidebar__profile-email {
  font-size: 12px;
  color: var(--fg-link);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.station-sidebar__profile-chevron {
  color: var(--fg-text-gray, var(--text-tertiary));
  flex-shrink: 0;
}

/* ─── 페이지 공통 헤더(타이틀) ──────────────────────────── */
.station-page__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 28px;
}

.station-page__title-help {
  color: var(--text-tertiary, var(--text-secondary));
  display: inline-flex;
}

.station-page__empty {
  padding: 80px 0;
  text-align: center;
  color: var(--text-tertiary, var(--text-secondary));
  font-size: 14px;
}

/* ================================================================
 * 내 에이전트 화면
 * ================================================================ */
.station-agents__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.station-agent-card {
  background: var(--surface, #fff);
  border: 1px solid var(--border, var(--fg-line));
  border-radius: var(--radius-lg, 8px);
  padding: 18px 20px 16px;
  transition: border-color var(--transition-fast, 0.15s ease), box-shadow var(--transition-fast, 0.15s ease);
}

.station-agent-card:hover {
  border-color: var(--primary-300, var(--fg-button));
  box-shadow: var(--shadow-sm);
}

.station-agent-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.station-agent-card__title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.station-agent-card__avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-full, 9999px);
  overflow: hidden;
  background: var(--surface, #fff);
}

.station-agent-card__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.station-agent-card__avatar-chat {
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--fg-bg-content, var(--gray-100));
  color: var(--fg-text-gray, var(--text-tertiary));
  border-radius: var(--radius-full, 9999px);
}

.station-agent-card__title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.station-agent-card__like {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: var(--error, #e84545);
  font-size: 13px;
  font-weight: 700;
}

.station-agent-card__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.station-agent-card__icon-btn {
  border: 0;
  background: transparent;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--fg-text-basic, var(--text-secondary));
}

.station-agent-card__icon-btn:hover {
  background: var(--fg-bg-content, var(--gray-100));
}

.station-agent-card__icon-btn--heart {
  color: var(--error, #e84545);
}

.station-agent-card__icon-btn--heart:hover {
  background: var(--error-light, var(--fg-bg-content));
}

.station-agent-card__desc {
  margin: 10px 0 14px;
  padding-left: 42px;
  font-size: 13px;
  line-height: 1.55;
  color: var(--text-secondary);
}

.station-agent-card__meta {
  padding-left: 42px;
  display: flex;
  gap: 14px;
  font-size: 12px;
  color: var(--text-tertiary, var(--text-secondary));
}

.station-agent-card__meta-sep {
  color: var(--border);
}

/* ================================================================
 * 에이전트 편집 모달
 * ================================================================ */
.station-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 17, 26, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.station-modal {
  background: var(--surface, #fff);
  border-radius: var(--radius-2xl, 12px);
  width: 100%;
  max-width: 640px;
  max-height: calc(100vh - 40px);
  overflow: auto;
  box-shadow: var(--shadow-xl);
  display: flex;
  flex-direction: column;
}

.station-modal__head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 24px;
  border-bottom: 1px solid var(--border);
}

.station-modal__head h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary);
}

.station-modal__body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.station-modal__section {
  border: 1px solid var(--border);
  border-radius: var(--radius-lg, 8px);
  overflow: hidden;
}

.station-modal__row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--border);
}

.station-modal__row:last-child {
  border-bottom: 0;
}

.station-modal__row-label {
  flex: 0 0 96px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding-top: 6px;
}

.station-modal__row-label .station-modal__row-required {
  color: var(--error, #e84545);
}

.station-modal__row-control {
  flex: 1 1;
  min-width: 0;
}

.station-modal__row-aside {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.station-modal__thumb {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-full, 9999px);
  position: relative;
  background: var(--surface);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.station-modal__thumb-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: var(--radius-full, 9999px);
}

.station-modal__thumb-cam {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 22px;
  height: 22px;
  border-radius: var(--radius-full);
  background: var(--surface);
  border: 1px solid var(--border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.station-modal__input,
.station-modal__textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 6px);
  padding: 10px 12px;
  font-size: 13px;
  color: var(--text-primary);
  background: var(--surface);
  font-family: inherit;
  box-sizing: border-box;
}

.station-modal__textarea {
  resize: vertical;
  min-height: 88px;
}

.station-modal__input:focus,
.station-modal__textarea:focus {
  outline: none;
  border-color: var(--fg-button, var(--primary-500));
  box-shadow: var(--focus-ring);
}

.station-modal__hint {
  font-size: 11px;
  color: var(--text-tertiary, var(--text-secondary));
  margin-top: 6px;
}

.station-modal__toggle {
  width: 36px;
  height: 20px;
  border-radius: var(--radius-full);
  background: var(--gray-300, #d4d4d8);
  border: 0;
  position: relative;
  cursor: pointer;
  transition: background var(--transition-fast);
}

.station-modal__toggle--on {
  background: var(--fg-button, var(--primary-500));
}

.station-modal__toggle::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: var(--radius-full);
  transition: transform var(--transition-fast);
}

.station-modal__toggle--on::after {
  transform: translateX(16px);
}

.station-modal__select {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-primary);
  cursor: pointer;
  min-width: 96px;
  justify-content: space-between;
}

.station-modal__invite-input {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  margin-bottom: 8px;
}

.station-modal__invite-input input {
  flex: 1 1;
  border: 0;
  outline: none;
  font-size: 12px;
  font-family: inherit;
  color: var(--text-primary);
  background: transparent;
}

.station-modal__invite-input button {
  border: 0;
  background: var(--fg-bg-litepp, var(--primary-50));
  color: var(--fg-text-purple, var(--primary-700));
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.station-modal__invitee {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: var(--radius-md);
}

.station-modal__invitee:hover {
  background: var(--fg-bg-content);
}

.station-modal__invitee-avatar {
  width: 22px;
  height: 22px;
  border-radius: var(--radius-full);
  background: var(--gray-200);
  font-size: 11px;
  font-weight: 700;
  color: var(--text-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.station-modal__invitee-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
}

.station-modal__invitee-email {
  flex: 1 1;
  font-size: 12px;
  color: var(--fg-link, var(--text-secondary));
}

.station-modal__invitee-x {
  border: 0;
  background: transparent;
  width: 20px;
  height: 20px;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.station-modal__invitee-x:hover {
  background: var(--fg-bg-content);
  color: var(--text-primary);
}

.station-modal__foot {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 14px 24px 24px;
}

.station-modal__btn {
  border: 0;
  border-radius: var(--radius-md);
  padding: 10px 22px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.station-modal__btn--primary {
  background: var(--fg-button, var(--primary-500));
  color: #fff;
}

.station-modal__btn--primary:hover {
  background: var(--fg-button-hover, var(--primary-600));
}

.station-modal__btn--ghost {
  background: var(--gray-200, #e5e7eb);
  color: var(--text-primary);
}

.station-modal__btn--ghost:hover {
  background: var(--gray-300);
}

/* ================================================================
 * 통계 화면 — 인라인 구성, 패널/경계선 없이 여백으로 분리
 * ================================================================ */

/* 도움말 아이콘 없는 단순 타이틀 변형 */
.station-page__title--plain {
  margin-bottom: 36px;
}

/* 접속량 섹션 */
.station-stats__section {
  margin-bottom: 56px;
}

.station-stats__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.station-stats__section-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, var(--text-primary));
  margin: 0;
}

/* 기간 탭 */
.station-stats__period {
  display: inline-flex;
  align-items: center;
  gap: 18px;
}

.station-stats__period-tab {
  border: 0;
  background: transparent;
  padding: 4px 0;
  cursor: pointer;
  font-size: 13px;
  color: var(--fg-text-gray, var(--text-secondary));
  font-family: inherit;
}

.station-stats__period-tab:hover {
  color: var(--fg-text-basic, var(--text-primary));
}

.station-stats__period-tab--active {
  color: var(--fg-text-basic, var(--text-primary));
  font-weight: 600;
  border-bottom: 1.5px solid var(--fg-text-basic, var(--text-primary));
}

.station-stats__period-refresh {
  border: 0;
  background: transparent;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--fg-text-gray, var(--text-secondary));
  margin-left: 4px;
}

.station-stats__period-refresh:hover {
  background: var(--fg-bg-content);
  color: var(--fg-text-basic);
}

/* 막대 차트 카드 — 옅은 회색 배경, 둥근 모서리 */
.station-stats__chart-card {
  background: var(--fg-bg-card);
  border-radius: var(--radius-lg, 8px);
  padding: 18px 16px 14px;
}

.station-stats__chart {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  height: 220px;
}

.station-stats__bar-col {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  height: 100%;
  min-width: 0;
}

.station-stats__bar-value {
  font-size: 12px;
  font-weight: 700;
  color: var(--fg-button, var(--primary-500));
  line-height: 1;
}

.station-stats__bar-track {
  flex: 1 1;
  width: 100%;
  max-width: 30px;
  background: var(--fg-bg-litepp);
  border-radius: 4px 4px 0 0;
  position: relative;
  overflow: hidden;
}

.station-stats__bar-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--fg-bg-litepp-hover);
  border-radius: 4px 4px 0 0;
  transition: height 0.3s ease;
  min-height: 4px;
}

.station-stats__bar-date {
  font-size: 11px;
  color: var(--fg-text-gray, var(--text-tertiary));
}

/* 랭킹 테이블 — 피그마 정확 매칭
 * 헤더: 14px Medium, border-bottom 1px var(--fg-text-basic) (다크)
 * 본문: 14px Regular, 각 행 border-bottom 1px var(--fg-line) (라이트)
 * 컬럼 폭: 50 / 1fr / 90 / 90 / 100, gap 20
 * 행 높이 57px, padding 20px vertical, line-height 1 */
.station-stats__rank-section {
  margin-bottom: 40px;
}

.station-stats__rank-thead,
.station-stats__rank-row {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 57px;
  padding: 20px 0;
  font-size: 14px;
  line-height: 1;
  color: var(--fg-text-basic);
  box-sizing: border-box;
}

.station-stats__rank-thead {
  font-weight: 500;
  border-bottom: 1px solid var(--fg-text-basic);
}

.station-stats__rank-row {
  font-weight: 400;
  border-bottom: 1px solid var(--fg-line);
}

.station-stats__rank-th,
.station-stats__rank-td {
  flex-shrink: 0;
  text-align: left;
}

.station-stats__rank-th--rank,
.station-stats__rank-td--rank {
  width: 50px;
}

.station-stats__rank-th--name,
.station-stats__rank-td--name {
  flex: 1 0;
  min-width: 0;
}

.station-stats__rank-th--num,
.station-stats__rank-td--num {
  width: 90px;
  text-align: left;
  padding-right: 0;
}

.station-stats__rank-th--date,
.station-stats__rank-td--date {
  width: 100px;
  text-align: left;
}

/* 랭킹 인디케이터 — 숫자와 아이콘 같은 색상 */
.station-stats__rank {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
}

.station-stats__rank-num {
  font-weight: 400;
}

.station-stats__rank--up,
.station-stats__rank--same {
  color: var(--fg-anti-red);
}

.station-stats__rank--down {
  color: var(--fg-link-hover);
}

.station-stats__rank-dash {
  font-weight: 400;
}

/* 토큰 소비량 (빨강), 접속량 (인디고) */
.station-stats__rank-td--token {
  color: var(--fg-anti-red);
}

.station-stats__rank-td--access {
  color: var(--fg-side-hover);
}

.station-stats__rank-td--date {
  color: var(--fg-text-basic);
}

/* 잔여 토큰 — 인라인 둥근 카드 */
.station-stats__token-bar {
  background: var(--fg-bg-toolbox, #4a4d5d);
  color: #fff;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 22px;
  border-radius: var(--radius-lg, 8px);
  margin-bottom: 32px;
}

.station-stats__token-label {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.station-stats__token-track {
  flex: 1 1;
  height: 6px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: var(--radius-full);
  overflow: hidden;
}

.station-stats__token-fill {
  height: 100%;
  background: var(--error, #e84545);
  border-radius: var(--radius-full);
}

.station-stats__token-value {
  font-size: 13px;
  font-weight: 700;
  color: var(--error, #ff7a7a);
  white-space: nowrap;
}

.station-stats__token-btn {
  border: 0;
  border-radius: var(--radius-md);
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: inherit;
  white-space: nowrap;
}

.station-stats__token-btn--ghost {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.station-stats__token-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.24);
}

.station-stats__token-btn--primary {
  background: var(--fg-button, var(--primary-500));
  color: #fff;
}

.station-stats__token-btn--primary:hover {
  background: var(--fg-button-hover, var(--primary-600));
}

/* ================================================================
 * 즐겨찾기 화면 — 피그마 시안(node 2-14866) 1:1
 *   리스트형 카드: 아바타 + 제목 + 랭킹 + 우측 하트 / 설명 / 메타
 * ================================================================ */
.station-fav__header {
  display: flex;
  align-items: center;
  margin: 0 0 20px;
}

.station-fav__title {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 28px;
  line-height: 40px;
  font-weight: 600;
  color: var(--fg-text-basic, var(--text-primary));
  letter-spacing: 0;
}

.station-fav__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.station-fav__item {
  display: block;
}

.station-fav__card {
  background: var(--surface, #fff);
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: var(--radius-2xl, 12px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.station-fav__card:hover {
  border-color: var(--fg-button, var(--primary-300));
  box-shadow: var(--shadow-sm);
}

.station-fav__card-head {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.station-fav__card-heading {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.station-fav__avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full, 9999px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: transparent;
}

.station-fav__avatar-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.station-fav__card-title {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: #464646;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.station-fav__rank {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  color: var(--anti-red-hover, var(--error-dark, #ff1500));
  white-space: nowrap;
}

.station-fav__like-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  border-radius: var(--radius-lg, 8px);
  cursor: pointer;
  color: var(--anti-red-hover, var(--error-dark, #ff1500));
  transition: background var(--transition-fast);
}

.station-fav__like-btn:hover {
  background: var(--fg-bg-content, var(--gray-100));
}

.station-fav__card-desc {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));
  word-break: break-word;
}

.station-fav__card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.station-fav__meta-author {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray, var(--text-tertiary, #838383));
}

.station-fav__meta-author > svg {
  flex-shrink: 0;
}

.station-fav__meta-text {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray, var(--text-tertiary, #838383));
  white-space: nowrap;
}

.station-fav__meta-sep {
  width: 1px;
  height: 12px;
  background: var(--fg-line, var(--border, #dbdbdb));
  display: inline-block;
}

/* ================================================================
 * 받은 메시지 화면 — 피그마 시안(node 2-14893, 2-14917, 2-14918) 1:1
 *   헤더 + 검색/정렬 툴바 + 카드형 메시지 리스트
 *   피그마는 우측 콘텐츠 컨테이너가 760px이므로 모든 섹션을 760px 좌측 정렬
 * ================================================================ */
.station-msg__header,
.station-msg__toolbar,
.station-msg__list,
.station-page__empty {
  width: 100%;
  max-width: 760px;
  margin-left: 0;
  margin-right: auto;
}

.station-msg__header {
  display: flex;
  align-items: center;
  margin: 0 auto 20px 0;
}

.station-msg__title {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic, var(--text-primary));
  letter-spacing: 0;
}

.station-msg__toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  margin-bottom: 12px;
}

.station-msg__search {
  position: relative;
  width: 240px;
  height: 42px;
}

.station-msg__search-input {
  width: 100%;
  height: 100%;
  padding: 7px 44px 7px 20px;
  background: var(--surface, #fff);
  border: 1px solid var(--fg-line, var(--border, #dbdbdb));
  border-radius: 30px;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));
  outline: none;
  box-sizing: border-box;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.station-msg__search-input::placeholder {
  color: var(--fg-text-gray, var(--text-tertiary, #838383));
}

.station-msg__search-input:focus {
  border-color: var(--fg-button, var(--primary-500));
}

.station-msg__search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--fg-text-gray, var(--text-tertiary, #838383));
  pointer-events: none;
}

.station-msg__sort {
  position: relative;
  width: 122px;
}

.station-msg__sort-trigger {
  width: 100%;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 16px;
  background: var(--surface, #fff);
  border: 1px solid var(--fg-line, var(--border, #dbdbdb));
  border-radius: var(--radius-lg, 8px);
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color var(--transition-fast);
}

.station-msg__sort-trigger:hover {
  border-color: var(--fg-button, var(--primary-300));
}

.station-msg__sort-label {
  flex: 1 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 24px;
}

.station-msg__sort--open .station-msg__sort-trigger {
  border-color: var(--fg-button, var(--primary-500));
}

.station-msg__sort-menu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  left: 0;
  list-style: none;
  margin: 0;
  padding: 4px;
  background: var(--surface, #fff);
  border: 1px solid var(--fg-line, var(--border, #dbdbdb));
  border-radius: var(--radius-lg, 8px);
  box-shadow: var(--shadow-md);
  z-index: 10;
}

.station-msg__sort-item {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 8px 10px;
  border-radius: var(--radius-md, 6px);
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));
  text-align: left;
  cursor: pointer;
}

.station-msg__sort-item:hover {
  background: var(--fg-bg-card, var(--gray-100));
}

.station-msg__sort-item--active {
  font-weight: 600;
  color: var(--fg-button, var(--primary-700));
  background: var(--fg-bg-litepp, var(--primary-50));
}

/* 리스트 — 박스/경계선 없이 단순 카드들의 세로 흐름 */
.station-msg__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  overflow: visible;
}

.station-msg__item-wrap {
  display: block;
}

.station-msg__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 12px;
  background: var(--surface, #fff);
  border-radius: var(--radius-2xl, 12px);
  border: 0;
  transition: background var(--transition-fast);
  cursor: pointer;
  box-sizing: border-box;
}

.station-msg__item:hover {
  background: var(--fg-bg-card, #fbfbfb);
}

.station-msg__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.station-msg__avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: var(--gray-200, #d9d9d9);
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0;
  color: transparent;
  font-weight: 400;
}

/* 프로필 이미지가 들어가기 전까지는 회색 원 placeholder만 노출 */
.station-msg__avatar-img {
  display: none;
}

.station-msg__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.station-msg__sender {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));
  width: 100%;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.station-msg__preview {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--fg-text-gray, var(--text-tertiary, #838383));
  width: 100%;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.station-msg__meta {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding-top: 4px;
}

.station-msg__item:hover .station-msg__meta {
  gap: 4px;
}

.station-msg__time {
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray, var(--text-tertiary, #838383));
  text-align: right;
  white-space: nowrap;
  line-height: 1;
}

.station-msg__delete {
  width: 32px;
  height: 32px;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  border-radius: var(--radius-lg, 8px);
  color: var(--fg-orange-warn, #ff7700);
  cursor: pointer;
  opacity: 0;
  transition: opacity var(--transition-fast), background var(--transition-fast);
}

.station-msg__item:hover .station-msg__delete {
  opacity: 1;
}

.station-msg__delete:hover {
  background: var(--fg-bg-content, var(--gray-100));
}

/* ================================================================
 * 고객 지원 화면 (피그마 2-14939)
 * - 상단 connect 리스트 (3개) + FAQ 아코디언 + footer
 * - 카드 컨테이너: bg gray-line + gap 1px → 내부 hairline 효과
 * ================================================================ */
.station-support__header {
  margin-bottom: 20px;
}

.station-support__title {
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic);
  margin: 0;
}

.station-support__section {
  margin-bottom: 20px;
}

.station-support__section-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
  margin: 0 0 12px;
}

/* 연결/문의 카드 그룹 — hairline 트릭 */
.station-support__connect-list {
  list-style: none;
  margin: 0;
  padding: 1px;
  background: var(--fg-line);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.station-support__connect-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--background);
  padding: 16px;
  min-height: 60px;
  box-sizing: border-box;
}

.station-support__connect-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--fg-text-basic);
}

.station-support__icon-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.station-support__connect-body {
  flex: 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.station-support__connect-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
  margin: 0;
}

.station-support__connect-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  margin: 0;
}

/* 우측 액션 버튼 — bg-lite-pp + purple text */
.station-support__action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  border: 0;
  border-radius: 4px;
  background: var(--fg-bg-litepp);
  color: var(--fg-button-hover);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
}

.station-support__action-btn:hover {
  background: var(--fg-bg-litepp-hover);
}

/* FAQ 아코디언 */
.station-support__faq-list {
  list-style: none;
  margin: 0;
  padding: 1px;
  background: var(--fg-line);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.station-support__faq-item {
  background: var(--background);
}

.station-support__faq-item:hover {
  background: var(--fg-bg-card);
}

.station-support__faq-item--open,
.station-support__faq-item--open:hover {
  background: var(--fg-bg-cool);
}

.station-support__faq-q {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 16px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  box-sizing: border-box;
}

.station-support__faq-q-text {
  flex: 1 0;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

.station-support__faq-q-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  color: var(--fg-text-basic);
  transition: transform 0.15s ease;
}

.station-support__faq-q-chevron--open {
  transform: rotate(180deg);
}

.station-support__faq-a {
  margin: 0;
  padding: 0 16px 16px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--fg-text-gray);
}

/* 푸터 */
.station-support__footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 12px;
}

.station-support__footer-logos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.station-support__footer-logo-gf {
  height: 36px;
  width: auto;
  display: block;
}

.station-support__footer-logo-bct {
  height: 24px;
  width: auto;
  display: block;
}

.station-support__footer-text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--fg-text-basic);
}

.station-support__footer-text strong {
  font-weight: 700;
}

.station-support__footer-copy {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--fg-text-basic);
}
`, "",{"version":3,"sources":["webpack://./src/css/Station.css"],"names":[],"mappings":"AAAA;;;;qEAIqE;;AAErE,2DAA2D;AAC3D;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,iDAAiD;EACjD,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf;sDACoD;AACtD;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mGAAmG;AACrG;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,oCAAoC;EACpC,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;;qEAEqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,oCAAoC;EACpC,uBAAuB;EACvB,0GAA0G;AAC5G;;AAEA;EACE,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,gDAAgD;EAChD,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;qEAEqE;AACrE;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kDAAkD;EAClD,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;qEAEqE;;AAErE,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,SAAS;AACX;;AAEA,SAAS;AACT;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,oEAAoE;AACtE;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gDAAgD;AAClD;;AAEA;;;;oDAIoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,SAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,yCAAyC;EACzC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;;qEAGqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yCAAyC;EACzC,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,wDAAwD;EACxD,6CAA6C;AAC/C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;;;;qEAIqE;AACrE;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,wDAAwD;EACxD,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yDAAyD;EACzD,aAAa;EACb,sBAAsB;EACtB,kFAAkF;AACpF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;EACzD,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,wDAAwD;EACxD,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yDAAyD;EACzD,eAAe;EACf,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gCAAgC;EAChC,wDAAwD;EACxD,oCAAoC;EACpC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,sCAAsC;EACtC,SAAS;EACT,6CAA6C;EAC7C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;EACzD,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;EACzD,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yDAAyD;EACzD,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,UAAU;EACV,6EAA6E;AAC/E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;;;qEAIqE;AACrE;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,OAAO;AACP;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B","sourcesContent":["/* ================================================================\n * Station — 그로우핏 스테이션 공통 셸 + 메뉴 페이지 스타일\n * 디자인 토큰만 사용 (var(--*)), raw hex 사용 금지\n * BEM: .station-* / .station-<page>__element--modifier\n * ================================================================ */\n\n/* ─── 레이아웃 셸 ─────────────────────────────────────────── */\n.station-layout {\n  display: flex;\n  min-height: 100vh;\n  background: var(--background);\n  color: var(--fg-text-basic);\n  font-family: var(--font-sans);\n}\n\n.station-layout__main {\n  flex: 1;\n  min-width: 0;\n  background: var(--background);\n}\n\n.station-layout__content {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 40px 48px 80px;\n}\n\n/* ─── 사이드바 ────────────────────────────────────────────── */\n.station-sidebar {\n  flex-shrink: 0;\n  width: 260px;\n  min-height: 100vh;\n  background: var(--fg-bg-cool);\n  border-right: 1px solid var(--fg-line, var(--border));\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  box-sizing: border-box;\n  transition: width var(--transition-fast, 0.15s ease);\n}\n\n.station-sidebar--collapsed {\n  width: 64px;\n  padding: 14px 8px 18px;\n  align-items: center;\n}\n\n.station-sidebar__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  align-self: flex-start;\n  border: 0;\n  background: transparent;\n  color: var(--fg-text-gray, var(--text-secondary));\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  padding: 6px 8px;\n  margin: 0 -8px 10px;\n  border-radius: var(--radius-md, 6px);\n  cursor: pointer;\n  transition: background var(--transition-fast, 0.15s ease),\n              color var(--transition-fast, 0.15s ease);\n}\n\n.station-sidebar__back:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.station-sidebar__back-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.station-sidebar--collapsed .station-sidebar__back {\n  align-self: center;\n  margin: 0 0 10px;\n  padding: 6px;\n}\n\n.station-sidebar__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 32px;\n  margin-bottom: 22px;\n}\n\n.station-sidebar--collapsed .station-sidebar__top {\n  justify-content: center;\n}\n\n.station-sidebar__brand {\n  display: inline-flex;\n  align-items: center;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-primary);\n  padding: 0;\n  height: 28px;\n}\n\n.station-sidebar__brand-img {\n  height: 24px;\n  width: auto;\n  display: block;\n}\n\n.station-sidebar__toggle {\n  border: 0;\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--fg-text-basic);\n}\n\n.station-sidebar__toggle:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.station-sidebar__nav {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 4px;\n}\n\n.station-sidebar__nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 14px;\n  border: 0;\n  border-radius: var(--radius-md, 6px);\n  background: transparent;\n  cursor: pointer;\n  color: var(--fg-text-basic);\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  transition: background var(--transition-fast, 0.15s ease), color var(--transition-fast, 0.15s ease);\n}\n\n.station-sidebar--collapsed .station-sidebar__nav-item {\n  justify-content: center;\n  padding: 10px 0;\n}\n\n.station-sidebar__nav-item:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--fg-text-basic);\n}\n\n.station-sidebar__nav-item--active {\n  background: var(--background);\n  color: var(--fg-text-basic);\n  font-weight: 600;\n  box-shadow: var(--shadow-sm);\n}\n\n.station-sidebar__nav-item--logout {\n  margin-top: 12px;\n}\n\n.station-sidebar__nav-icon {\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.station-sidebar__nav-label {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.station-sidebar__nav-badge {\n  font-size: 12px;\n  color: var(--fg-text-gray, var(--text-tertiary));\n  font-weight: 500;\n}\n\n/* 사이드바 하단 — 알림 벨 + 프로필 카드 */\n.station-sidebar__bottom {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-top: 10px;\n}\n\n.station-sidebar__bell {\n  position: relative;\n  border: 0;\n  background: transparent;\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-md, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--fg-text-basic);\n}\n\n.station-sidebar__bell:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.station-sidebar__bell-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--error, #e84545);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.station-sidebar__profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 0;\n  border-radius: var(--radius-lg, 8px);\n  background: var(--background);\n  cursor: pointer;\n  text-align: left;\n  transition: background var(--transition-fast, 0.15s ease);\n  box-shadow: var(--shadow-sm);\n}\n\n.station-sidebar__profile:hover {\n  background: var(--surface);\n}\n\n.station-sidebar__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--gray-200, #e5e7eb);\n  color: var(--text-primary);\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 13px;\n  overflow: hidden;\n}\n\n.station-sidebar__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.station-sidebar__profile-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.station-sidebar__profile-head {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.station-sidebar__profile-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.station-sidebar__profile-divider {\n  color: var(--border, #d1d5db);\n  font-size: 11px;\n}\n\n.station-sidebar__profile-plan {\n  font-size: 11px;\n  color: var(--fg-text-gray, var(--text-tertiary));\n}\n\n.station-sidebar__profile-email {\n  font-size: 12px;\n  color: var(--fg-link);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.station-sidebar__profile-chevron {\n  color: var(--fg-text-gray, var(--text-tertiary));\n  flex-shrink: 0;\n}\n\n/* ─── 페이지 공통 헤더(타이틀) ──────────────────────────── */\n.station-page__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 28px;\n}\n\n.station-page__title-help {\n  color: var(--text-tertiary, var(--text-secondary));\n  display: inline-flex;\n}\n\n.station-page__empty {\n  padding: 80px 0;\n  text-align: center;\n  color: var(--text-tertiary, var(--text-secondary));\n  font-size: 14px;\n}\n\n/* ================================================================\n * 내 에이전트 화면\n * ================================================================ */\n.station-agents__list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.station-agent-card {\n  background: var(--surface, #fff);\n  border: 1px solid var(--border, var(--fg-line));\n  border-radius: var(--radius-lg, 8px);\n  padding: 18px 20px 16px;\n  transition: border-color var(--transition-fast, 0.15s ease), box-shadow var(--transition-fast, 0.15s ease);\n}\n\n.station-agent-card:hover {\n  border-color: var(--primary-300, var(--fg-button));\n  box-shadow: var(--shadow-sm);\n}\n\n.station-agent-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.station-agent-card__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.station-agent-card__avatar {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-full, 9999px);\n  overflow: hidden;\n  background: var(--surface, #fff);\n}\n\n.station-agent-card__avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.station-agent-card__avatar-chat {\n  width: 100%;\n  height: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--fg-bg-content, var(--gray-100));\n  color: var(--fg-text-gray, var(--text-tertiary));\n  border-radius: var(--radius-full, 9999px);\n}\n\n.station-agent-card__title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.station-agent-card__like {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  color: var(--error, #e84545);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.station-agent-card__actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.station-agent-card__icon-btn {\n  border: 0;\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--fg-text-basic, var(--text-secondary));\n}\n\n.station-agent-card__icon-btn:hover {\n  background: var(--fg-bg-content, var(--gray-100));\n}\n\n.station-agent-card__icon-btn--heart {\n  color: var(--error, #e84545);\n}\n\n.station-agent-card__icon-btn--heart:hover {\n  background: var(--error-light, var(--fg-bg-content));\n}\n\n.station-agent-card__desc {\n  margin: 10px 0 14px;\n  padding-left: 42px;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n\n.station-agent-card__meta {\n  padding-left: 42px;\n  display: flex;\n  gap: 14px;\n  font-size: 12px;\n  color: var(--text-tertiary, var(--text-secondary));\n}\n\n.station-agent-card__meta-sep {\n  color: var(--border);\n}\n\n/* ================================================================\n * 에이전트 편집 모달\n * ================================================================ */\n.station-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 17, 26, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.station-modal {\n  background: var(--surface, #fff);\n  border-radius: var(--radius-2xl, 12px);\n  width: 100%;\n  max-width: 640px;\n  max-height: calc(100vh - 40px);\n  overflow: auto;\n  box-shadow: var(--shadow-xl);\n  display: flex;\n  flex-direction: column;\n}\n\n.station-modal__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 18px 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n.station-modal__head h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.station-modal__body {\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.station-modal__section {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg, 8px);\n  overflow: hidden;\n}\n\n.station-modal__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--border);\n}\n\n.station-modal__row:last-child {\n  border-bottom: 0;\n}\n\n.station-modal__row-label {\n  flex: 0 0 96px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding-top: 6px;\n}\n\n.station-modal__row-label .station-modal__row-required {\n  color: var(--error, #e84545);\n}\n\n.station-modal__row-control {\n  flex: 1;\n  min-width: 0;\n}\n\n.station-modal__row-aside {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.station-modal__thumb {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--radius-full, 9999px);\n  position: relative;\n  background: var(--surface);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.station-modal__thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: var(--radius-full, 9999px);\n}\n\n.station-modal__thumb-cam {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 22px;\n  height: 22px;\n  border-radius: var(--radius-full);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n}\n\n.station-modal__input,\n.station-modal__textarea {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md, 6px);\n  padding: 10px 12px;\n  font-size: 13px;\n  color: var(--text-primary);\n  background: var(--surface);\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.station-modal__textarea {\n  resize: vertical;\n  min-height: 88px;\n}\n\n.station-modal__input:focus,\n.station-modal__textarea:focus {\n  outline: none;\n  border-color: var(--fg-button, var(--primary-500));\n  box-shadow: var(--focus-ring);\n}\n\n.station-modal__hint {\n  font-size: 11px;\n  color: var(--text-tertiary, var(--text-secondary));\n  margin-top: 6px;\n}\n\n.station-modal__toggle {\n  width: 36px;\n  height: 20px;\n  border-radius: var(--radius-full);\n  background: var(--gray-300, #d4d4d8);\n  border: 0;\n  position: relative;\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n\n.station-modal__toggle--on {\n  background: var(--fg-button, var(--primary-500));\n}\n\n.station-modal__toggle::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: #fff;\n  border-radius: var(--radius-full);\n  transition: transform var(--transition-fast);\n}\n\n.station-modal__toggle--on::after {\n  transform: translateX(16px);\n}\n\n.station-modal__select {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  padding: 6px 10px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  min-width: 96px;\n  justify-content: space-between;\n}\n\n.station-modal__invite-input {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  margin-bottom: 8px;\n}\n\n.station-modal__invite-input input {\n  flex: 1;\n  border: 0;\n  outline: none;\n  font-size: 12px;\n  font-family: inherit;\n  color: var(--text-primary);\n  background: transparent;\n}\n\n.station-modal__invite-input button {\n  border: 0;\n  background: var(--fg-bg-litepp, var(--primary-50));\n  color: var(--fg-text-purple, var(--primary-700));\n  font-size: 12px;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n}\n\n.station-modal__invitee {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: var(--radius-md);\n}\n\n.station-modal__invitee:hover {\n  background: var(--fg-bg-content);\n}\n\n.station-modal__invitee-avatar {\n  width: 22px;\n  height: 22px;\n  border-radius: var(--radius-full);\n  background: var(--gray-200);\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.station-modal__invitee-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.station-modal__invitee-email {\n  flex: 1;\n  font-size: 12px;\n  color: var(--fg-link, var(--text-secondary));\n}\n\n.station-modal__invitee-x {\n  border: 0;\n  background: transparent;\n  width: 20px;\n  height: 20px;\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.station-modal__invitee-x:hover {\n  background: var(--fg-bg-content);\n  color: var(--text-primary);\n}\n\n.station-modal__foot {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px 24px 24px;\n}\n\n.station-modal__btn {\n  border: 0;\n  border-radius: var(--radius-md);\n  padding: 10px 22px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.station-modal__btn--primary {\n  background: var(--fg-button, var(--primary-500));\n  color: #fff;\n}\n\n.station-modal__btn--primary:hover {\n  background: var(--fg-button-hover, var(--primary-600));\n}\n\n.station-modal__btn--ghost {\n  background: var(--gray-200, #e5e7eb);\n  color: var(--text-primary);\n}\n\n.station-modal__btn--ghost:hover {\n  background: var(--gray-300);\n}\n\n/* ================================================================\n * 통계 화면 — 인라인 구성, 패널/경계선 없이 여백으로 분리\n * ================================================================ */\n\n/* 도움말 아이콘 없는 단순 타이틀 변형 */\n.station-page__title--plain {\n  margin-bottom: 36px;\n}\n\n/* 접속량 섹션 */\n.station-stats__section {\n  margin-bottom: 56px;\n}\n\n.station-stats__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.station-stats__section-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, var(--text-primary));\n  margin: 0;\n}\n\n/* 기간 탭 */\n.station-stats__period {\n  display: inline-flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.station-stats__period-tab {\n  border: 0;\n  background: transparent;\n  padding: 4px 0;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--fg-text-gray, var(--text-secondary));\n  font-family: inherit;\n}\n\n.station-stats__period-tab:hover {\n  color: var(--fg-text-basic, var(--text-primary));\n}\n\n.station-stats__period-tab--active {\n  color: var(--fg-text-basic, var(--text-primary));\n  font-weight: 600;\n  border-bottom: 1.5px solid var(--fg-text-basic, var(--text-primary));\n}\n\n.station-stats__period-refresh {\n  border: 0;\n  background: transparent;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-md);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--fg-text-gray, var(--text-secondary));\n  margin-left: 4px;\n}\n\n.station-stats__period-refresh:hover {\n  background: var(--fg-bg-content);\n  color: var(--fg-text-basic);\n}\n\n/* 막대 차트 카드 — 옅은 회색 배경, 둥근 모서리 */\n.station-stats__chart-card {\n  background: var(--fg-bg-card);\n  border-radius: var(--radius-lg, 8px);\n  padding: 18px 16px 14px;\n}\n\n.station-stats__chart {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  height: 220px;\n}\n\n.station-stats__bar-col {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  height: 100%;\n  min-width: 0;\n}\n\n.station-stats__bar-value {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--fg-button, var(--primary-500));\n  line-height: 1;\n}\n\n.station-stats__bar-track {\n  flex: 1;\n  width: 100%;\n  max-width: 30px;\n  background: var(--fg-bg-litepp);\n  border-radius: 4px 4px 0 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.station-stats__bar-fill {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: var(--fg-bg-litepp-hover);\n  border-radius: 4px 4px 0 0;\n  transition: height 0.3s ease;\n  min-height: 4px;\n}\n\n.station-stats__bar-date {\n  font-size: 11px;\n  color: var(--fg-text-gray, var(--text-tertiary));\n}\n\n/* 랭킹 테이블 — 피그마 정확 매칭\n * 헤더: 14px Medium, border-bottom 1px var(--fg-text-basic) (다크)\n * 본문: 14px Regular, 각 행 border-bottom 1px var(--fg-line) (라이트)\n * 컬럼 폭: 50 / 1fr / 90 / 90 / 100, gap 20\n * 행 높이 57px, padding 20px vertical, line-height 1 */\n.station-stats__rank-section {\n  margin-bottom: 40px;\n}\n\n.station-stats__rank-thead,\n.station-stats__rank-row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  height: 57px;\n  padding: 20px 0;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--fg-text-basic);\n  box-sizing: border-box;\n}\n\n.station-stats__rank-thead {\n  font-weight: 500;\n  border-bottom: 1px solid var(--fg-text-basic);\n}\n\n.station-stats__rank-row {\n  font-weight: 400;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.station-stats__rank-th,\n.station-stats__rank-td {\n  flex-shrink: 0;\n  text-align: left;\n}\n\n.station-stats__rank-th--rank,\n.station-stats__rank-td--rank {\n  width: 50px;\n}\n\n.station-stats__rank-th--name,\n.station-stats__rank-td--name {\n  flex: 1 0 0;\n  min-width: 0;\n}\n\n.station-stats__rank-th--num,\n.station-stats__rank-td--num {\n  width: 90px;\n  text-align: left;\n  padding-right: 0;\n}\n\n.station-stats__rank-th--date,\n.station-stats__rank-td--date {\n  width: 100px;\n  text-align: left;\n}\n\n/* 랭킹 인디케이터 — 숫자와 아이콘 같은 색상 */\n.station-stats__rank {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.station-stats__rank-num {\n  font-weight: 400;\n}\n\n.station-stats__rank--up,\n.station-stats__rank--same {\n  color: var(--fg-anti-red);\n}\n\n.station-stats__rank--down {\n  color: var(--fg-link-hover);\n}\n\n.station-stats__rank-dash {\n  font-weight: 400;\n}\n\n/* 토큰 소비량 (빨강), 접속량 (인디고) */\n.station-stats__rank-td--token {\n  color: var(--fg-anti-red);\n}\n\n.station-stats__rank-td--access {\n  color: var(--fg-side-hover);\n}\n\n.station-stats__rank-td--date {\n  color: var(--fg-text-basic);\n}\n\n/* 잔여 토큰 — 인라인 둥근 카드 */\n.station-stats__token-bar {\n  background: var(--fg-bg-toolbox, #4a4d5d);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 18px 22px;\n  border-radius: var(--radius-lg, 8px);\n  margin-bottom: 32px;\n}\n\n.station-stats__token-label {\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.station-stats__token-track {\n  flex: 1;\n  height: 6px;\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.station-stats__token-fill {\n  height: 100%;\n  background: var(--error, #e84545);\n  border-radius: var(--radius-full);\n}\n\n.station-stats__token-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--error, #ff7a7a);\n  white-space: nowrap;\n}\n\n.station-stats__token-btn {\n  border: 0;\n  border-radius: var(--radius-md);\n  padding: 7px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-family: inherit;\n  white-space: nowrap;\n}\n\n.station-stats__token-btn--ghost {\n  background: rgba(255, 255, 255, 0.16);\n  color: #fff;\n}\n\n.station-stats__token-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.station-stats__token-btn--primary {\n  background: var(--fg-button, var(--primary-500));\n  color: #fff;\n}\n\n.station-stats__token-btn--primary:hover {\n  background: var(--fg-button-hover, var(--primary-600));\n}\n\n/* ================================================================\n * 즐겨찾기 화면 — 피그마 시안(node 2-14866) 1:1\n *   리스트형 카드: 아바타 + 제목 + 랭킹 + 우측 하트 / 설명 / 메타\n * ================================================================ */\n.station-fav__header {\n  display: flex;\n  align-items: center;\n  margin: 0 0 20px;\n}\n\n.station-fav__title {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 28px;\n  line-height: 40px;\n  font-weight: 600;\n  color: var(--fg-text-basic, var(--text-primary));\n  letter-spacing: 0;\n}\n\n.station-fav__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.station-fav__item {\n  display: block;\n}\n\n.station-fav__card {\n  background: var(--surface, #fff);\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: var(--radius-2xl, 12px);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  cursor: pointer;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.station-fav__card:hover {\n  border-color: var(--fg-button, var(--primary-300));\n  box-shadow: var(--shadow-sm);\n}\n\n.station-fav__card-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.station-fav__card-heading {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.station-fav__avatar {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full, 9999px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: transparent;\n}\n\n.station-fav__avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.station-fav__card-title {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #464646;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.station-fav__rank {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--anti-red-hover, var(--error-dark, #ff1500));\n  white-space: nowrap;\n}\n\n.station-fav__like-btn {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  padding: 2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: transparent;\n  border-radius: var(--radius-lg, 8px);\n  cursor: pointer;\n  color: var(--anti-red-hover, var(--error-dark, #ff1500));\n  transition: background var(--transition-fast);\n}\n\n.station-fav__like-btn:hover {\n  background: var(--fg-bg-content, var(--gray-100));\n}\n\n.station-fav__card-desc {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));\n  word-break: break-word;\n}\n\n.station-fav__card-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.station-fav__meta-author {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray, var(--text-tertiary, #838383));\n}\n\n.station-fav__meta-author > svg {\n  flex-shrink: 0;\n}\n\n.station-fav__meta-text {\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray, var(--text-tertiary, #838383));\n  white-space: nowrap;\n}\n\n.station-fav__meta-sep {\n  width: 1px;\n  height: 12px;\n  background: var(--fg-line, var(--border, #dbdbdb));\n  display: inline-block;\n}\n\n/* ================================================================\n * 받은 메시지 화면 — 피그마 시안(node 2-14893, 2-14917, 2-14918) 1:1\n *   헤더 + 검색/정렬 툴바 + 카드형 메시지 리스트\n *   피그마는 우측 콘텐츠 컨테이너가 760px이므로 모든 섹션을 760px 좌측 정렬\n * ================================================================ */\n.station-msg__header,\n.station-msg__toolbar,\n.station-msg__list,\n.station-page__empty {\n  width: 100%;\n  max-width: 760px;\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.station-msg__header {\n  display: flex;\n  align-items: center;\n  margin: 0 auto 20px 0;\n}\n\n.station-msg__title {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic, var(--text-primary));\n  letter-spacing: 0;\n}\n\n.station-msg__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 100%;\n  margin-bottom: 12px;\n}\n\n.station-msg__search {\n  position: relative;\n  width: 240px;\n  height: 42px;\n}\n\n.station-msg__search-input {\n  width: 100%;\n  height: 100%;\n  padding: 7px 44px 7px 20px;\n  background: var(--surface, #fff);\n  border: 1px solid var(--fg-line, var(--border, #dbdbdb));\n  border-radius: 30px;\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.station-msg__search-input::placeholder {\n  color: var(--fg-text-gray, var(--text-tertiary, #838383));\n}\n\n.station-msg__search-input:focus {\n  border-color: var(--fg-button, var(--primary-500));\n}\n\n.station-msg__search-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--fg-text-gray, var(--text-tertiary, #838383));\n  pointer-events: none;\n}\n\n.station-msg__sort {\n  position: relative;\n  width: 122px;\n}\n\n.station-msg__sort-trigger {\n  width: 100%;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 8px 8px 16px;\n  background: var(--surface, #fff);\n  border: 1px solid var(--fg-line, var(--border, #dbdbdb));\n  border-radius: var(--radius-lg, 8px);\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: border-color var(--transition-fast);\n}\n\n.station-msg__sort-trigger:hover {\n  border-color: var(--fg-button, var(--primary-300));\n}\n\n.station-msg__sort-label {\n  flex: 1;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 24px;\n}\n\n.station-msg__sort--open .station-msg__sort-trigger {\n  border-color: var(--fg-button, var(--primary-500));\n}\n\n.station-msg__sort-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  left: 0;\n  list-style: none;\n  margin: 0;\n  padding: 4px;\n  background: var(--surface, #fff);\n  border: 1px solid var(--fg-line, var(--border, #dbdbdb));\n  border-radius: var(--radius-lg, 8px);\n  box-shadow: var(--shadow-md);\n  z-index: 10;\n}\n\n.station-msg__sort-item {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 8px 10px;\n  border-radius: var(--radius-md, 6px);\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));\n  text-align: left;\n  cursor: pointer;\n}\n\n.station-msg__sort-item:hover {\n  background: var(--fg-bg-card, var(--gray-100));\n}\n\n.station-msg__sort-item--active {\n  font-weight: 600;\n  color: var(--fg-button, var(--primary-700));\n  background: var(--fg-bg-litepp, var(--primary-50));\n}\n\n/* 리스트 — 박스/경계선 없이 단순 카드들의 세로 흐름 */\n.station-msg__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  overflow: visible;\n}\n\n.station-msg__item-wrap {\n  display: block;\n}\n\n.station-msg__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  padding: 12px;\n  background: var(--surface, #fff);\n  border-radius: var(--radius-2xl, 12px);\n  border: 0;\n  transition: background var(--transition-fast);\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.station-msg__item:hover {\n  background: var(--fg-bg-card, #fbfbfb);\n}\n\n.station-msg__main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.station-msg__avatar {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 20px;\n  background: var(--gray-200, #d9d9d9);\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0;\n  color: transparent;\n  font-weight: 400;\n}\n\n/* 프로필 이미지가 들어가기 전까지는 회색 원 placeholder만 노출 */\n.station-msg__avatar-img {\n  display: none;\n}\n\n.station-msg__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.station-msg__sender {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--fg-text-basic, var(--text-primary, #3b3b3b));\n  width: 100%;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n}\n\n.station-msg__preview {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--fg-text-gray, var(--text-tertiary, #838383));\n  width: 100%;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n}\n\n.station-msg__meta {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n  padding-top: 4px;\n}\n\n.station-msg__item:hover .station-msg__meta {\n  gap: 4px;\n}\n\n.station-msg__time {\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray, var(--text-tertiary, #838383));\n  text-align: right;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.station-msg__delete {\n  width: 32px;\n  height: 32px;\n  padding: 2px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: transparent;\n  border-radius: var(--radius-lg, 8px);\n  color: var(--fg-orange-warn, #ff7700);\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity var(--transition-fast), background var(--transition-fast);\n}\n\n.station-msg__item:hover .station-msg__delete {\n  opacity: 1;\n}\n\n.station-msg__delete:hover {\n  background: var(--fg-bg-content, var(--gray-100));\n}\n\n/* ================================================================\n * 고객 지원 화면 (피그마 2-14939)\n * - 상단 connect 리스트 (3개) + FAQ 아코디언 + footer\n * - 카드 컨테이너: bg gray-line + gap 1px → 내부 hairline 효과\n * ================================================================ */\n.station-support__header {\n  margin-bottom: 20px;\n}\n\n.station-support__title {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic);\n  margin: 0;\n}\n\n.station-support__section {\n  margin-bottom: 20px;\n}\n\n.station-support__section-title {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  margin: 0 0 12px;\n}\n\n/* 연결/문의 카드 그룹 — hairline 트릭 */\n.station-support__connect-list {\n  list-style: none;\n  margin: 0;\n  padding: 1px;\n  background: var(--fg-line);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.station-support__connect-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--background);\n  padding: 16px;\n  min-height: 60px;\n  box-sizing: border-box;\n}\n\n.station-support__connect-icon {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--fg-text-basic);\n}\n\n.station-support__icon-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.station-support__connect-body {\n  flex: 1 0 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.station-support__connect-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  margin: 0;\n}\n\n.station-support__connect-subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  margin: 0;\n}\n\n/* 우측 액션 버튼 — bg-lite-pp + purple text */\n.station-support__action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  border: 0;\n  border-radius: 4px;\n  background: var(--fg-bg-litepp);\n  color: var(--fg-button-hover);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  text-decoration: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.station-support__action-btn:hover {\n  background: var(--fg-bg-litepp-hover);\n}\n\n/* FAQ 아코디언 */\n.station-support__faq-list {\n  list-style: none;\n  margin: 0;\n  padding: 1px;\n  background: var(--fg-line);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.station-support__faq-item {\n  background: var(--background);\n}\n\n.station-support__faq-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.station-support__faq-item--open,\n.station-support__faq-item--open:hover {\n  background: var(--fg-bg-cool);\n}\n\n.station-support__faq-q {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 12px;\n  min-height: 52px;\n  padding: 16px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.station-support__faq-q-text {\n  flex: 1 0 0;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n.station-support__faq-q-chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  color: var(--fg-text-basic);\n  transition: transform 0.15s ease;\n}\n\n.station-support__faq-q-chevron--open {\n  transform: rotate(180deg);\n}\n\n.station-support__faq-a {\n  margin: 0;\n  padding: 0 16px 16px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--fg-text-gray);\n}\n\n/* 푸터 */\n.station-support__footer {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-bottom: 12px;\n}\n\n.station-support__footer-logos {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.station-support__footer-logo-gf {\n  height: 36px;\n  width: auto;\n  display: block;\n}\n\n.station-support__footer-logo-bct {\n  height: 24px;\n  width: auto;\n  display: block;\n}\n\n.station-support__footer-text {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--fg-text-basic);\n}\n\n.station-support__footer-text strong {\n  font-weight: 700;\n}\n\n.station-support__footer-copy {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--fg-text-basic);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
